var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmallRowOfferEl',{attrs:{"template-item-data":_vm.templateItemData}},[_c('div',{staticClass:"text--start"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.templateItemData.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }